const PUSHER_APP_KEY = "5895fa81b97c48b944e7";
const PUSHER_CLUSTER = "eu";

export {PUSHER_APP_KEY, PUSHER_CLUSTER}